/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import './verification';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "model": {
            "nested": {
              "VendorInteraction": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "profile": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "vendorMedia": {
                    "type": ".squareup.identityverifier.model.VendorInteraction.VendorMedia",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "inProgressStatus": {
                    "type": ".squareup.identityverifier.model.VendorInteraction.InProgressStatus",
                    "id": 4
                  },
                  "completedStatus": {
                    "type": ".squareup.identityverifier.model.VendorInteraction.CompletedStatus",
                    "id": 5
                  },
                  "erroredStatus": {
                    "type": ".squareup.identityverifier.model.VendorInteraction.ErroredStatus",
                    "id": 6
                  }
                },
                "nested": {
                  "InProgressStatus": {
                    "fields": {
                      "requestId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "interactiveUserSession": {
                        "type": ".squareup.identityverifier.model.InteractiveUserSession",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CompletedStatus": {
                    "fields": {
                      "completedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "contentType": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "content": {
                        "type": "bytes",
                        "id": 5,
                        "rule": "optional"
                      },
                      "interpretation": {
                        "type": ".squareup.identityverifier.model.Interpretation",
                        "id": 6,
                        "rule": "optional"
                      },
                      "decision": {
                        "type": ".squareup.identityverifier.model.Decision",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErroredStatus": {
                    "fields": {
                      "erroredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cause": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "requestId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "VendorMedia": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "size": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      },
                      "mediaType": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "docboxToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "status": {
                    "oneof": ["inProgressStatus", "completedStatus", "erroredStatus"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.VendorInteraction && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.VendorInteraction?.nested?.InProgressStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.VendorInteraction?.nested?.CompletedStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.VendorInteraction?.nested?.ErroredStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.VendorInteraction?.nested?.VendorMedia) {
  $root.addJSON(jsonData);
}

/**
 * The vendor interaction sub-resource.
 *
 * SOURCE VendorInteraction @ squareup/identityverifier/model/vendor.proto at 14:1
 */
export const VendorInteraction = $root.lookupType('squareup.identityverifier.model.VendorInteraction');
fixType(VendorInteraction, {
  name: {
    notEmpty: true
  },
  profile: {
    notEmpty: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(VendorInteraction);
/**
 * Data container for vendor interactions that are currently in progress.
 *
 * SOURCE InProgressStatus @ squareup/identityverifier/model/vendor.proto at 42:3
 */
VendorInteraction.InProgressStatus = $root.lookupType('squareup.identityverifier.model.VendorInteraction.InProgressStatus');
fixType(VendorInteraction.InProgressStatus);
Builder.createAndAttachToType(VendorInteraction.InProgressStatus);
/**
 * Container for successfully completed vendor interactions. Contains IDV vendor response, along
 * with interpretation of matched attributes and possibly a decision (if the used vendor profile
 * is configured to produce one).
 *
 * Interpretation is immutable, taking place when the vendor response is originally received.
 *
 * SOURCE CompletedStatus @ squareup/identityverifier/model/vendor.proto at 57:3
 */
VendorInteraction.CompletedStatus = $root.lookupType('squareup.identityverifier.model.VendorInteraction.CompletedStatus');
fixType(VendorInteraction.CompletedStatus, {
  completedAt: {
    required: true
  },
  requestId: {
    notEmpty: true
  },
  comment: {
    notEmpty: true
  },
  contentType: {
    notEmpty: true
  },
  content: {
    required: true
  },
  interpretation: {
    required: true
  }
});
Builder.createAndAttachToType(VendorInteraction.CompletedStatus);
/**
 * Data container for vendor interactions that terminate in an error.
 *
 * SOURCE ErroredStatus @ squareup/identityverifier/model/vendor.proto at 88:3
 */
VendorInteraction.ErroredStatus = $root.lookupType('squareup.identityverifier.model.VendorInteraction.ErroredStatus');
fixType(VendorInteraction.ErroredStatus, {
  erroredAt: {
    required: true
  },
  cause: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VendorInteraction.ErroredStatus);
/**
 * Media used by the vendor during verification. Typically a document image, but could include
 * video or audio depending on the vendor and verification settings.
 *
 * SOURCE VendorMedia @ squareup/identityverifier/model/vendor.proto at 102:3
 */
VendorInteraction.VendorMedia = $root.lookupType('squareup.identityverifier.model.VendorInteraction.VendorMedia');
fixType(VendorInteraction.VendorMedia, {
  name: {
    notEmpty: true
  },
  size: {
    required: true
  },
  mediaType: {
    notEmpty: true
  },
  docboxToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VendorInteraction.VendorMedia);